import { render, staticRenderFns } from "./campos.cadastro.vue?vue&type=template&id=5aca31a0&"
import script from "./campos.cadastro.vue?vue&type=script&lang=js&"
export * from "./campos.cadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports